import config from 'Cloud/config';

export const DOM_ID_INSIDE_PHONE_DATALIST = config.get('DOM_ID_INSIDE_PHONE_DATALIST');
export const DOM_ID_RIGHT_COL_BANNER_ERRORS_PAGE = config.get('DOM_ID_RIGHT_COL_BANNER_ERRORS_PAGE');
export const DOM_ID_PHONE_HEADER_ERRORS_PAGE = config.get('DOM_ID_PHONE_HEADER_ERRORS_PAGE');
